// extracted by mini-css-extract-plugin
export default {"empty":"CellBasicInfo_empty__apITE","note":"CellBasicInfo_note__AgYT2","perOrganoid":"CellBasicInfo_perOrganoid__IYc8G","perOrganoidKey":"CellBasicInfo_perOrganoidKey__Ruash"};